import React from 'react'
import { inject, observer } from 'src/core/store'
import './index.less'
import { setDocumentTitle, setUidToken } from 'src/helper/tool'
import DropScreen from '../../../component/DropScreen/index'
import ThumbsUp from './thumbsUp'
import TopLovers from './topLovers'
import lang from './lang'
import { getlang, setlang } from 'src/helper/getlang'

@inject('store')
@observer

export default class Couples extends React.Component {
  constructor(props) {
    super(props)
  }
  state = {
    showTab:0,
    lang:lang.en,
    language:'en',
  }

  async componentDidMount() {
    let { language } = this.props.location.query
    const uid = await setUidToken(this.props.location.query)
    language =await getlang(language)
    if (language == 'ar') {
      setDocumentTitle("عيد الحب")
    }else if ( language == 'tr') {
      setDocumentTitle("Sevgililer Günü")
    } else{
      setDocumentTitle("Valentine's Day")
    }
     this.setState({
      lang: setlang(language, lang),
      language: language,
      uid
    })
  }

  handleTab = (e)=>{
    this.setState({
      showTab:e
    })
  }

  render() {
    let { showTab, lang }  = this.state
   
    return (
      <div className={`valentine-day ${this.state.language == 'ar' ? 'arlang' : ''}`}>

        {/* 屏幕爱心 */}
        <DropScreen></DropScreen>
        {/* 点赞 */}
        <div className='fixed-root'>
          {showTab == 0 && <div className='left-btn' onClick={()=>this.handleTab(0)}>{lang?lang.treeOfLovers:''}</div>}
          {showTab == 1 && <div className='right-btn' onClick={()=>this.handleTab(0)}>{lang?lang.treeOfLovers:''}</div>}
          {showTab == 1 && <div className='left-btn' onClick={()=>this.handleTab(1)}>{lang?lang.topLovers:''}</div>}
          {showTab == 0 && <div className='right-btn' onClick={()=>this.handleTab(1)}>{lang?lang.topLovers:''}</div>}

        </div>
        {showTab == 0 && <ThumbsUp location={this.props.location} key={1}></ThumbsUp>}
        {showTab == 1 && <TopLovers location={this.props.location} key={2}></TopLovers>}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/valentineDay/index.js